import styled, { withTheme } from "styled-components";
import * as variables from "./variables"

export default styled.div`
.main-index{
  width:100%;
   min-height:100vh;
   position: relative;
   z-index: 1;
      /* background-image:url("/imagess/Vector 13.png"),url("/imagess/Vector 13.png"),url("/imagess/Vector 13.png");
    background-repeat:no-repeat,no-repeat,no-repeat;
    background-size:1251.7px 700.3px,1251.7px 700.3px,1251.7px 700.3px;
    background-position:140%  10%,-400%  50%,140%  80%; */
}
.back1{
position: absolute;
top: 500px;
right: 0;

}
.back2{
position: absolute;
top: 1000px;
left: 0;

}
.back3{
position: absolute;
top: 1700px;
right: 0;

}
.back4{
position: absolute;
top: 400px;
right: 0;
width:600px;
height:600px;

}
.back5{
position: absolute;
top: 900px;
left: 0;
width:600px;
height:600px;

}

.back6{
position: absolute;
top: 1600px;
right: 0;
width:600px;
height:600px;

}
.back7{
position: absolute;
top: 1300px;
right: 300px;
width:600px;
height:600px;

}
.sliderbg{
  width:100%;
  background-color: #2f3640;
}
.dateclas{
  width: 100%;
  height: 56px;
  background-color:#EEEEEE;
  border-radius:10px;
  border:none;
  padding-right:7px;
  padding-left:7px;
}
.mainbuy{
  width:100%;
  display: flex;
  flex-direction: column;
  margin-top:30px;
  margin-bottom:  20px;
}

.buytitle{
  font-weight: bold;
  font-size: 25px;
  color:#3D3939;
  text-align:center; 
  margin-bottom:15px;
  margin-right:auto;
  margin-left:auto;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    font-size: 30px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    font-size: 35px;
  }

}

.buytext{
  font-size: 14px;
  color:#737373;
  text-align:center; 
  margin-bottom:  20px;
  width: 300px;
  margin-right:auto;
  margin-left:auto;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    font-size: 16px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 550px;
    font-size: 19px;
  }
}

.buymaincardrow{
  display: flex;
  flex-direction:column;
  width:90%;
  margin-right:5%;
  margin-left:5%; 
  margin-right:auto;
  margin-left:auto;
  flex-wrap:wrap;
  margin-top:20px;
  margin-bottom:50px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    flex-direction:row;
    max-width: 700px;
    justify-content:space-between;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    flex-direction:row;
    max-width: 1200px;
  }
}

.buymaincard{
  display: flex;
  flex-direction:column;
  width:100%;
  border-Radius:20px;
  border:1px solid #E6E6E6;
  padding:30px 20px;
  height: auto;
  position: relative;
  padding-bottom:100px;
  overflow:hidden;
  max-width:295px;
  margin-right: auto;
  margin-left:auto;
  margin-bottom:15px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
  width:45%;
  /* margin-right:2.5%;
  margin-left:2.5%; */
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
  width:23%;
  /* margin-right:0.5%;
  margin-left:0.5%; */
  }
}

.buymaincardcircle{
  width:30px;
 height:30px;
 border-Radius:15px;
 margin-bottom:15px;
 display: flex;
    justify-content: center;
    align-items: center;
    background-color: #E8E8E8;
 @media (min-width: ${variables.Breakpoints.Tablet}) {
    font-size: 16px;
    width:35px;
 height:35px;
 border-Radius:17.5px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    font-size: 19px;
    width:40px;
 height:40px;
 border-Radius:20px;
  }
}

.buycardtitle{
  font-weight: bold;
  font-size: 16px;
  color:#1161A6;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    font-size: 17px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    font-size: 19px;
  }
}


.buycardtext{
  font-size: 14px;
  color:#737373;
  margin-top:10px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    font-size: 14px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    font-size: 14px;
  }
}

.maincardbottomcircle{
  position: absolute;
  bottom: -14px;
  left:-7px;
  width: 75px;
  height: 75px;
  border-radius:37.5px;
  background-color:#1161A6;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    bottom: -18px;
  left:-10px;
    width: 80px;
  height: 80px;
  border-radius:40px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 100px;
  height: 100px;
  border-radius:50px;
  bottom: -34px;
  left:-15px;
  }
}

.maincardbottomcircleIcon{
  width:30px;
  height:30px;
  margin-top:16px;
  margin-right:18px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    width:32px;
  height:32px;
  margin-top:16px;
  margin-right:18px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 32px;
  height: 32px;
  margin-top:20px;
  margin-right:28px;
  }
}

.maincardbottomcircleIcon2{
  width:32px;
  height:32px;
  margin-top:16px;
  margin-right:18px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    width:34px;
  height:34px;
  margin-top:16px;
  margin-right:18px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 36px;
  height: 36px;
  margin-top:20px;
  margin-right:28px;
  }
}

.maincompanyes{
  width: 320px;
  height:110px;
  margin-right:auto;
  margin-left: auto;
  margin-bottom:40px;
  display: flex;
  flex-direction:row;
  align-items:center;
  overflow-x:hidden;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    width:530px;
    height:110px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width:760px;
    height:110px;
  }
}

.companybox{
  width: 160px;
  height: 68px;
  display: flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  border:1px solid #E6E6E6;
  border-radius: 17px;
  padding-right:10px;
  padding-left:10px;
  margin-left:10px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    border-radius: 20px;
    width: 160px;
  height: 78px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    border-radius: 22px;
    width: 160px;
  height: 88px;
  }
}

.companyboxtext{
  font-size:14px;
  color:#3D3939;
}

.companyboxicon{
  max-width: 100px;
  max-height:100px;
  margin-left:10px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    max-width: 100px;
  max-height:100px;
  margin-left:10px;
  }
}

.maincomments{
  display: flex;
  flex-direction:column;
  width:90%;
  margin-right:5%;
  margin-left:5%; 
  margin-right:auto;
  margin-left:auto;
  flex-wrap:wrap;
  margin-top:20px;
  margin-bottom:50px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    flex-direction:row;
    max-width: 700px;
    justify-content:space-between;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    flex-direction:row;
    max-width: 1200px;
  }
}

.cammentscard{
  position:relative;
  display: flex;
  flex-direction:column;
  width:100%;
  max-width: 290px;
  height:250px;
  margin-right:auto;
  margin-left:auto;
  background-color:#ffffff;
  border-radius: 10px;
  padding: 25px 10px;
  box-sizing:border-box;
  margin-bottom:15px;
  border:0.5px solid #E3E3E3;
  box-shadow: 0 3px 6px 0 #E6E6E6;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    border-radius: 15px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    margin-bottom:20px;
    padding: 30px 15px;
    border-radius:20px;
    width: 30%;
    max-width:390px;
    height:330px;
  }
}

.cammentscardtitle{
  font-size:17px;
  color:#F76B09;
  margin-bottom:10px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    font-size:18px;
 margin-bottom:15px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    font-size:20px;
  }
}

.cammentscardtext{
  width:100%;
  height: 150px;;
color:#9B9B9B;
font-size:15px;
@media (min-width: ${variables.Breakpoints.Laptop}) {
  font-size:16px;
  height: 170px;;
}
}

.cammentscardpersonname{
  width:100%;
color:#737373;
font-size:15px;
@media (min-width: ${variables.Breakpoints.Laptop}) {
  font-size:16px;
}
}

.cammentscardpersondescription{
  width:100%;
color:#737373;
margin-top:5px;
font-size:15px;
@media (min-width: ${variables.Breakpoints.Laptop}) {
  font-size:14px;
}
}

.cammentscardimge{
  position: absolute;
  top:-25px;
 left: 30px;
  width: 64px;
  height: 64px;

}

.selected{
  display: flex;
  flex-direction:column;
  width:100%;
}

.mainselectedbox{
  width: 300px;
  height: 100px;
  margin-right:auto;
  margin-left:auto;
  border-radius:10px;
  box-shadow: 0 3px 6px 2px #E6E6E6;
  display: flex;
  flex-direction:row;
  margin-bottom:20px;
  align-items:center;
  overflow-x:auto;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
width: 500px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 800px;
    border-radius:15px;
  }
}
.mainselectedbox2{
  position:relative;
  width: 300px;
  height: 100px;
  margin-right:auto;
  margin-left:auto;
  display: flex;
  flex-direction:row;
  margin-bottom:20px;
  align-items:center;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
width: 550px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 800px;
  }
}
.mainselectedbox3{
  width: 300px;
  height: 100px;
  margin-right:auto;
  margin-left:auto;
  border-radius:10px;
  box-shadow: 0 3px 6px 2px #E6E6E6;
  display: flex;
  flex-direction:row;
  margin-bottom:20px;
  align-items:center;
overflow-x:hidden;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
    width: 500px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 800px;
    border-radius:15px;
  }
}

.mainscrool{
  display: flex;
  flex-direction:row;
  width:auto;
}
.boximage{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  @media (min-width: ${variables.Breakpoints.Tablet}) {
width:82px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 133.33333px;
  }
}

.arrowback{
  position: absolute;
top: 18px;
left: -30px;
display: flex;

@media (min-width: ${variables.Breakpoints.Tablet}) {
    width: 800px;
    display: none;
  }
}

.arrownext{
  position: absolute;
top: 18px;
right: -30px;
display: flex;
@media (min-width: ${variables.Breakpoints.Tablet}) {
    width: 800px;
    display: none;
  }
}

.mainselectedimg{
  width: 85px;
  height: 85px;
}


.mainselectedim2{
  width: 75px;
  height: 65px;
}

.mainremember{
  width:90%;
margin-right:auto;
margin-left : auto;
  border-radius:10px;
  box-shadow: 0 3px 6px 2px #E6E6E6;
  display: flex;
  flex-direction:column;
  margin-bottom:20px;
  margin-top:50px;
  padding: 10px;

  @media (min-width: ${variables.Breakpoints.Tablet}) {
    max-width: 700px;
  }
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    display: flex;
  flex-direction:row;
  max-width: 1200px;
    border-radius:15px;
    justify-content:space-between;
    padding-left:100px;
    padding-top:20px;
  }
}

.rememberimage{
  width:100%;
  height:200px;
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width:403px;
  height:533px;
  }
}

.rememberleft{
  width: 100%;
  display: flex;
  flex-direction:column;
  padding-top:10px;
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 600px;
    padding-top:20px;
  }
}

.remembertitle{
  font-size:20px;
  font-weight:bold;
  color:#3D3939;
  margin-top:10px;
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    margin-top:-20px;
    font-size:25px;
  }
}

.remembertext{
  font-size:15px;
  margin-top:15px;
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    font-size:16px;
    width: 500px;
    margin-top: 15px;
  }
}

.mainrowdate{
  display: flex;
  flex-direction:row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top:30px;
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    margin-top:20px;
  }
}

.mainrowcol{
  display: flex;
  flex-direction: column;
  width: 45%;
  
}

.selectclass{
  background-color:#EEEEEE
}
.datetext{
  font-size:15px;
  margin-bottom:7px;
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    font-size:16px;
  }
}
.dateInput{
  width: 100%;
  height: 56px;
  background-color:#EEEEEE;
  border-radius:10px;
  border:none;
  padding-right:7px;
  padding-left:7px;
}

.textareaclass{
width:100%;
height: 110px;
background-color:#EEEEEE;
border-radius: 7px;
border:none;
padding:10px;
padding-top:15px;
margin-top: 10px;
@media (min-width: ${variables.Breakpoints.Laptop}) {
  height: 110px;
  border-radius: 10px;
  margin-top: 20px;
}
}

.rememberbtn{
  width: 116px;
  height: 40px;
  font-size:15px;
  background-color: #F76B09;
  color:#ffffff;
  border-radius: 5px;
  border:1px solid #F76B09;
  margin-right:calc(100% - 116px);
  margin-top: 10px;
  @media (min-width: ${variables.Breakpoints.Laptop}) {
    width: 136px;
  height: 44px;
  font-size:16px;
  margin-right:calc(100% - 136px);
  margin-top: 20px;
  }
  /* margin-right: ; */
}
/* ************************************ */
`;
